module.exports = __webpack_public_path__ + "img/random-icon.12848048.svg";